import { getEnv, IAnyStateTreeNode } from 'mobx-state-tree';
import { Client } from 'urql';

export interface GlobalVariables {
  urqlClient: Client;
}

export const getUrqlClient = (self: IAnyStateTreeNode): Client => {
  return getEnv<GlobalVariables>(self).urqlClient;
};
